const VARIANTS = {
  success: {
    base: "bg-green-50 text-green-700 border-green-200 dark:bg-green-500/10 dark:text-green-300 dark:border-green-500/30",
    dot: "bg-green-500",
    flicker: "bg-green-400",
  },
  danger: {
    base: "bg-red-50 text-red-700 border-red-200 dark:bg-red-500/10 dark:text-red-300 dark:border-red-500/30",
    dot: "bg-red-500",
    flicker: "bg-red-400",
  },
  warning: {
    base: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:border-amber-500/30",
    dot: "bg-amber-500",
    flicker: "bg-amber-400",
  },
  info: {
    base: "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-500/10 dark:text-blue-300 dark:border-blue-500/30",
    dot: "bg-blue-500",
    flicker: "bg-blue-400",
  },
  neutral: {
    base: "bg-gray-50 text-gray-600 border-gray-200 dark:bg-gray-700/30 dark:text-gray-300 dark:border-gray-600",
    dot: "bg-gray-400",
    flicker: "bg-gray-300",
  },
};

const StatusPill = ({
  value,
  variant = "neutral",
  flicker,
  onClick,
  disabled = false,
  className = "",
  ...rest
}) => {
  const v = VARIANTS[variant] ?? VARIANTS.neutral;
  const flickerColor = flicker?.color ?? v.flicker;
  const interactive = typeof onClick === "function";
  const Tag = interactive ? "button" : "span";

  const interactiveCls = interactive
    ? "cursor-pointer transition-all duration-200 ease-out hover:shadow-sm active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-slate-900 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100"
    : "";

  return (
    <Tag
      {...(interactive ? { type: "button", onClick, disabled } : {})}
      className={`py-2 my-auto inline-flex items-center gap-2 rounded-lg border px-3 py-1 text-xs font-semibold leading-none ${v.base} ${interactiveCls} ${className}`}
      {...rest}
    >
      <span className="relative flex h-2 w-2 flex-shrink-0">
        {flicker && (
          <span
            className={`absolute inline-flex h-full w-full animate-ping rounded-full opacity-60 ${flickerColor}`}
          />
        )}
        <span className={`relative inline-flex h-2 w-2 rounded-full ${v.dot}`} />
      </span>
      {value}
    </Tag>
  );
};

export default StatusPill;
